
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Taxiserviceatmumbaiinternationalairport() {



    const cardData =
    {
        keyword: ' Taxi Service at Mumbai International Airport',
        heading: 'Deva Cabs:  Taxi Service at Mumbai International Airport',
        headingDescription: 'Deva Cabs offers reliable, punctual, and hassle-free taxi services at Mumbai International Airport. Whether you are arriving late at night or catching an early morning flight, our professional drivers and clean, air-conditioned cabs ensure a smooth airport transfer experience. We provide timely pickups and drop-offs from Terminal 1 and Terminal 2, with a range of vehicles to suit solo travelers, families, or corporate guests. With 24/7 availability, transparent fares, and courteous service, Deva Cabs guarantees a stress-free and comfortable airport travel experience every time.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "location": "Churchgate to Nariman Point, South Mumbai, Maharashtra",
    "description": "This 3 km curved boulevard—dubbed the “Queen’s Necklace” for its jewel-like night-time lights—is lined with art‑deco buildings (UNESCO‑listed). A hotspot for evening walks, sea breeze, and street food at Chowpatty Beach. Photo ops abound during sunset as the bay glimmers and the skyline comes alive."
  },
    {
    "title": "Gateway of India",
    "location": "Apollo Bunder, Colaba, Mumbai, Maharashtra",
    "description": "An iconic Indo-Saracenic triumphal arch built in 1924 to commemorate King George V’s visit, and famously where the last British troops left India in 1948. The 26 m basalt structure overlooks the Arabian Sea, serving as a lively gathering spot for ferry rides to Elephanta Island, bhelpuri vendors, and street performers. Sunset vistas and proximity to the Taj Mahal Palace make it a must-see landmark."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Fort, Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage site and major transit hub, this Victorian-Gothic marvel built in 1888 features ornate domes, turrets, and stained glass. Packed with history and architecture buffs, it’s also famous for appearances in ‘Slumdog Millionaire’ and is central to Kala Ghoda and Fort heritage walks."
  },
  {
    "title": "Elephanta Caves (Gharapuri Island)",
    "location": "Elephanta Island, Mumbai Harbour, Maharashtra",
    "description": "A UNESCO World Heritage complex of 5th–8th century rock‑cut Hindu caves renowned for the 6 m high Trimurti statue. Accessible via ferry from the Gateway of India (~1 hr ride), the island also offers light snacks, toy‑train rides, and souvenir stalls along the ascent."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    "location": "Fort, Mumbai, Maharashtra",
    "description": "Formerly the Prince of Wales Museum, this grand Indo-Saracenic building houses over 70,000 artifacts, including miniature paintings, Gandharan sculptures, coins, and decorative arts. Nestled amidst Fort’s art galleries and colonial structures, it's perfect for cultural immersion and heritage lovers."
  },
  {
    "title": "Kala Ghoda Art Precinct",
    "location": "Kala Ghoda, Fort, Mumbai, Maharashtra",
    "description": "A vibrant cultural district blanketed with museums (NGMA, Jehangir), galleries, cafés, and boutiques. The annual Kala Ghoda Arts Festival (February) brings street art, performances, workshops and heritage walks — a creative hotspot in South Mumbai."
  },
  {
    "title": "Juhu Beach",
    "location": "Juhu, Mumbai Suburban, Maharashtra",
    "description": "A beloved stretch of sand visited year-round, famous for its vibrant food stalls serving bhelpuri, pani puri, and sev puri. Locals and tourists enjoy evening strolls, fitness sessions, Ganesh Chaturthi celebrations, and occasional plane-spotting due to its proximity to the airport."
  },
  {
    "title": "Dhobi Ghat",
    "location": "Mahalaxmi, Mumbai, Maharashtra",
    "description": "The world’s largest open-air laundry established in 1890. Witness 7,000+ washerfolk (dhobis) hand-washing, pounding, and sun-drying over 100,000 garments daily. A slice of Mumbai’s living heritage—and a compelling documentary-style photo stop."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai Village, Borivali West, Mumbai, Maharashtra",
    "description": "Inspired by Myanmar’s Shwedagon Pagoda, this colossal golden stupa (96 m high) houses Asia’s largest meditation hall seating 8,000. Free 10‑minute Anapana sessions, tranquil lake views, and vegetarian dosas are offered—perfect for mindfulness seekers."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "location": "Bandra to Worli, Mumbai, Maharashtra",
    "description": "A stunning cable-stayed bridge opened in 2009 that connects western suburbs to South Mumbai, featuring sweeping sea views and cityscapes. Drive across by day for sea breezes, or by night for neon-lit panoramas—perfectly framed from nearby Bandra Fort viewpoints."
  },
  {
    "title": "Malabar Hill Elevated Nature Trail",
    "location": "Malabar Hill, South Mumbai, Maharashtra",
    "description": "A recent addition that revives a 12 acre tropical forest with a 482 m elevated walkway and native flora/fauna like kingfishers and parakeets. Ideal for peaceful walks, limiting visitors to preserve its biodiversity, and offering skyline views over Chowpatty."
  }
],



  "services": [
    {
      "name": "Taxi Service at Mumbai International Airport",
      "description": "Deva Cabs provides reliable and convenient taxi service at Mumbai International Airport (Chhatrapati Shivaji Maharaj International Airport), ensuring a smooth start or end to your journey. Whether you're arriving late at night or departing early in the morning, our 24x7 airport taxi service offers clean, air-conditioned vehicles, professional drivers, and real-time flight tracking. Avoid the hassle of long queues and enjoy door-to-door pickup or drop service with transparent pricing. From solo business travelers to large families, our fleet of sedans, SUVs, and luxury cars can accommodate every need with comfort and ease."
    },
    {
      "name": "Airport Taxi Mumbai",
      "description": "Book your airport taxi in Mumbai with Deva Cabs for a seamless travel experience. Our trained chauffeurs ensure timely pickups and drops, navigating Mumbai traffic efficiently. All vehicles are GPS-enabled and well-maintained for safety and cleanliness. Whether it’s a domestic or international terminal, our drivers arrive on time and assist with luggage. Choose from economical or premium options depending on your budget and travel preference. 24/7 availability ensures you're never stranded at the airport."
    },
    {
      "name": "Prepaid Airport Cab Mumbai",
      "description": "Avoid fare negotiations and enjoy fixed pricing with our prepaid airport cab service in Mumbai. Ideal for tourists and corporate clients, our prepaid booking option ensures you know the cost upfront. Just select your vehicle, pay online or via mobile app, and we’ll assign a cab that meets you at the terminal with a placard. Perfect for hassle-free airport transfers with complete transparency and no hidden charges."
    },
    {
      "name": "Mumbai Airport Pickup Taxi",
      "description": "Arriving in Mumbai? Our airport pickup taxi service ensures that a professional driver is waiting for you at the arrival gate. Whether you’re returning home or visiting Mumbai, we offer timely pickups, assistance with luggage, and comfortable vehicles to take you to your destination. Avoid the stress of navigating public transport or finding a last-minute cab — pre-book with Deva Cabs and ride in peace."
    },
    {
      "name": "Mumbai International Airport Drop Service",
      "description": "Need to catch a flight on time? Deva Cabs offers prompt drop services to Mumbai International Airport. Our drivers are familiar with airport entry points and traffic patterns, ensuring timely arrival. With live traffic tracking and 24/7 customer support, you can travel worry-free. Suitable for business travelers, tourists, and locals alike — our airport drop service is available throughout Mumbai and nearby suburbs."
    },
    {
      "name": "Book Cab at Mumbai Airport",
      "description": "Booking a cab at Mumbai airport is quick and easy with Deva Cabs. Whether you need an instant ride upon arrival or want to pre-schedule your airport transfer, we provide multiple booking options — mobile app, website, or phone call. Choose from a range of AC cabs, including sedans, SUVs, and luxury vehicles. Instant confirmations, upfront pricing, and courteous drivers make us the preferred choice for airport commuting."
    },
    {
      "name": "24x7 Airport Cab Mumbai",
      "description": "Flights don’t follow a 9-to-5 schedule, and neither do we. Our 24x7 airport cab service in Mumbai is always ready to serve you — day or night. Whether you’re arriving at midnight or flying out early in the morning, our round-the-clock operations ensure you never have to wait. All vehicles are equipped with safety features, AC, and trained drivers for reliable airport transfers at any hour."
    },
    {
      "name": "Chauffeur Airport Taxi Mumbai",
      "description": "Experience a premium airport transfer with our chauffeur-driven taxi service in Mumbai. Our well-groomed, polite drivers offer meet-and-greet service at the terminal, assist with baggage, and ensure a smooth ride to your destination. Perfect for VIP clients, senior citizens, or anyone looking for a touch of professionalism and comfort during airport transfers."
    },
    {
      "name": "Online Airport Cab Booking Mumbai",
      "description": "Book your airport cab online in Mumbai with just a few clicks. Our website and mobile app allow real-time booking, secure payment, and instant confirmation. You can select pickup/drop points, vehicle type, and preferred time slot. Whether you need a one-time trip or recurring airport commutes, our system offers convenience, transparency, and reliability with every ride."
    },
    {
      "name": "Affordable Mumbai Airport Taxi",
      "description": "Looking for budget-friendly airport transport? Deva Cabs offers economical taxi services to and from Mumbai International Airport without compromising on comfort or safety. We provide clear fare estimates upfront, no surge pricing, and competitive rates for solo travelers or groups. Our affordable cabs include comfortable sedans, perfect for short and long commutes."
    },
    {
      "name": "Luxury Cab at Mumbai Airport",
      "description": "Upgrade your airport journey with our luxury cab service in Mumbai. Whether you're entertaining a business client or seeking personal comfort, our fleet of high-end cars including BMW, Audi, and Mercedes is available for airport transfers. Enjoy plush seating, onboard refreshments (on request), and priority customer service for a premium travel experience."
    },
    {
      "name": "SUV Cab Airport Mumbai",
      "description": "Traveling with family or extra luggage? Our SUV cab service at Mumbai airport is ideal for groups needing more space and comfort. Choose from models like Innova Crysta, Ertiga, or Xylo. Spacious interiors, AC comfort, and reliable drivers make it perfect for intercity airport transfers, sightseeing, or direct home drops across the city."
    },
    {
      "name": "Mumbai Airport Sedan Taxi",
      "description": "Our sedan taxi service at Mumbai airport is perfect for quick, stylish, and comfortable airport commutes. Choose from reliable models like Toyota Etios, Swift Dzire, or Honda Amaze for your solo or couple travel. All sedans are regularly serviced, fitted with AC, and driven by trained chauffeurs for a seamless airport travel experience."
    },
    {
      "name": "Instant Cab Mumbai Airport",
      "description": "Need a taxi from Mumbai airport on the spot? Deva Cabs offers instant cab service with minimal waiting. As soon as you land, open our app or call our helpline and get matched with a nearby cab within minutes. Ideal for last-minute changes, unplanned arrivals, or emergency travel — your ride will always be just a few clicks away."
    }
  ],

  "tableData": [
    ["Taxi Service at Mumbai International Airport", "-Airport Taxi Mumbai"],
    ["Prepaid Airport Cab Mumbai", "-Mumbai Airport Pickup Taxi"],
    ["Mumbai International Airport Drop Service", "-Book Cab at Mumbai Airport"],
    ["24x7 Airport Cab Mumbai", "-Chauffeur Airport Taxi Mumbai"],
    ["Online Airport Cab Booking Mumbai", "-Affordable Mumbai Airport Taxi"],
    ["Luxury Cab at Mumbai Airport", "-SUV Cab Airport Mumbai"],
    ["Mumbai Airport Sedan Taxi", "-Instant Cab Mumbai Airport"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Airport Pickup and Drop Service",
    "WhyChoosedescription": "Deva Cabs ensures that your journey to or from Mumbai International Airport is smooth, punctual, and stress-free. Whether you’re arriving from a long flight or heading out for a business trip, our drivers track your flight status to guarantee timely service, even if your flight is delayed or arrives early."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our airport taxi drivers are well-trained, polite, and experienced in airport protocols. From assisting you with your luggage to choosing the fastest routes, they deliver a premium experience from the moment you exit the terminal to the time you reach your destination."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Traveler",
    "WhyChoosedescription": "Whether you need a compact sedan, a luxury car, or an SUV with extra luggage space, Deva Cabs offers clean, air-conditioned, and well-maintained vehicles for every travel need. Relax in comfort after a long flight or enjoy a smooth ride to the airport with plenty of room for your bags."
  },
  {
    "WhyChooseheading": "24/7 Taxi Availability at Mumbai Airport",
    "WhyChoosedescription": "Flights operate round the clock—and so do we. Deva Cabs provides taxi services to and from Chhatrapati Shivaji Maharaj International Airport 24/7, including holidays and weekends. No matter when your flight lands or departs, we’ll be there on time, every time."
  },
  {
    "WhyChooseheading": "Fixed and Transparent Airport Taxi Fare",
    "WhyChoosedescription": "Avoid the stress of bargaining or surge pricing. Our airport taxi fares are pre-calculated and completely transparent. You’ll receive a full breakdown of costs before you book—no hidden fees, no last-minute surprises, just fair pricing you can rely on."
  },
  {
    "WhyChooseheading": "Easy Booking and Real-Time Tracking",
    "WhyChoosedescription": "Book your airport taxi in seconds through our mobile app, website, or call center. Get instant confirmation and real-time driver tracking, so you know exactly when your cab is arriving. Our system also updates you with driver contact details and pickup instructions right at the terminal."
  },
  {
    "WhyChooseheading": "Meet & Greet Service Available",
    "WhyChoosedescription": "Traveling with guests or clients? Opt for our professional Meet & Greet service where our driver will wait at the arrival gate with a placard, assist with luggage, and guide them to the car—perfect for first-time visitors, senior citizens, or business travelers."
  },
  {
    "WhyChooseheading": "Custom Packages for Frequent Flyers and Corporates",
    "WhyChoosedescription": "Deva Cabs offers special rates and priority booking for frequent flyers, corporate accounts, and travel partners. Enjoy monthly billing, priority pickups, and customizable packages tailored to your company’s airport travel needs."
  }
]












    }




const faqData = [
  {
    question: "Can I book a taxi from Mumbai International Airport with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable taxi services to and from Mumbai International Airport. You can book a taxi easily via our website, mobile app, or by contacting our customer support."
  },
  {
    question: "Are the taxis available for both pick-up and drop-off at Mumbai International Airport?",
    answer: "Yes, we provide both pick-up and drop-off services at Mumbai International Airport for both domestic and international flights."
  },
  {
    question: "How do I book a taxi from Mumbai International Airport?",
    answer: "You can book a taxi directly from the airport by visiting our booking desk, or you can pre-book a ride via our mobile app or website for added convenience."
  },
  {
    question: "Are the taxis available 24/7 at Mumbai International Airport?",
    answer: "Yes, our taxi service operates 24/7, ensuring that you can book a ride anytime you need, whether it’s for early morning arrivals or late-night departures."
  },
  {
    question: "What are the payment options for taxi services at Mumbai International Airport?",
    answer: "We accept various payment methods including cash, credit/debit cards, UPI, and online payments through our mobile app or website."
  },
  {
    question: "Are the taxi drivers experienced for Mumbai International Airport trips?",
    answer: "Yes, all our drivers are experienced, verified, and familiar with the routes to and from Mumbai International Airport, ensuring a smooth and safe ride."
  },
  {
    question: "Is it safe to travel by taxi from Mumbai International Airport with Deva Cabs?",
    answer: "Absolutely! All our taxis are GPS-enabled, and we ensure the highest safety standards with professional drivers to make your journey safe and comfortable."
  },
  {
    question: "Can I pre-schedule a taxi from Mumbai International Airport?",
    answer: "Yes, you can pre-schedule your taxi ride in advance for airport pick-up or drop-off through our booking portal or mobile app."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Rahul Sharma',
    role: 'Frequent Traveler',
    review: 'I often use Deva Cabs for pick-up and drop-off services at Mumbai International Airport. The drivers are punctual, and the service is always top-notch. I never have to worry about missing my flight!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Anjali Kapoor',
    role: 'Tourist',
    review: 'My first experience with Deva Cabs was when I landed at Mumbai International Airport. The driver was waiting for me with a sign, and the ride to my hotel was smooth and comfortable. Highly recommend!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service at Mumbai International Airport",
  "image": "https://devacab.com/assets/images/taxi-service-mumbai-international-airport.jpg", // Replace with actual image URL
  "description": "24x7 taxi service at Mumbai International Airport by Deva Cabs. Book prepaid airport cabs for pickup or drop with AC sedans, SUVs, and luxury cars. Instant booking, professional chauffeurs, and affordable fares available online.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // Example base fare, update if needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/taxi-service-mumbai-international-airport" // Replace with actual page URL
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Taxi Service at Mumbai International Airport | 24x7 Airport Cab | Deva Cabs</title>
  <meta
    name="description"
    content="Book 24x7 taxi service at Mumbai International Airport with Deva Cabs. Affordable prepaid cabs for airport pickup & drop. AC sedans, SUVs, chauffeur-driven, and luxury taxis available instantly."
  />
  <meta
    name="keywords"
    content="Taxi Service at Mumbai International Airport, Airport taxi Mumbai, Prepaid airport cab Mumbai, Mumbai airport pickup taxi, Mumbai international airport drop service, Book cab at Mumbai airport, 24x7 airport cab Mumbai, Chauffeur airport taxi Mumbai, Online airport cab booking Mumbai, Affordable Mumbai airport taxi, Luxury cab at Mumbai airport, SUV cab airport Mumbai, Mumbai airport sedan taxi, Instant cab Mumbai airport"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Taxiserviceatmumbaiinternationalairport;